<div class="swal-icon swal-icon--success">
  <span class="swal-icon--success__line swal-icon--success__line--long"></span>
  <span class="swal-icon--success__line swal-icon--success__line--tip"></span>
  <div class="swal-icon--success__ring"></div>
  <div class="swal-icon--success__hide-corners"></div>
</div>
